import {VideoDisplayType, VideoFormatType} from './VideoFormat';

export class VideoLink {
    constructor(public format: VideoFormatType, public display: VideoDisplayType) {
    }
}
